module.exports = __webpack_public_path__ + "img/info_icon.5f8bda49.svg";